import { Controller } from '@hotwired/stimulus';

// 「1,000」のようにカンマ区切りで入力中の見た目を整え、
// submit 時に数字のみに戻して送信するためのコントローラー。
export default class extends Controller {
  static targets = ['input'];

  connect() {
    this.formatInput();
  }

  formatInput() {
    if (!this.hasInputTarget) return;
    this.inputTarget.value = this.formatWithComma(this.inputTarget.value);
  }

  onInput(event) {
    event.target.value = this.formatWithComma(event.target.value);
  }

  onSubmit() {
    if (!this.hasInputTarget) return;
    this.inputTarget.value = this.toDigits(this.inputTarget.value);
  }

  toDigits(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  formatWithComma(value) {
    const digits = this.toDigits(value);
    return digits === '' ? '' : Number(digits).toLocaleString('ja-JP');
  }
}
